"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var DropdownToggleButton = function (_a) {
    var toggleDropdown = _a.toggleDropdown, isOpened = _a.isOpened;
    return (react_1.default.createElement("div", { className: "gd-measure-format-button gd-measure-format-button-templates s-measure-format-templates-toggle-button", onClick: toggleDropdown },
        react_1.default.createElement("span", null,
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "measureNumberCustomFormatDialog.template.title" })),
        react_1.default.createElement("div", { className: classnames_1.default("gd-measure-format-button-icon-right", isOpened ? "gd-icon-navigateup" : "gd-icon-navigatedown") })));
};
exports.default = DropdownToggleButton;
//# sourceMappingURL=DropdownToggleButton.js.map